import clickCancel, {
    HhtmFromLabel,
} from '@hh.ru/analytics-js-events/build/xhh/applicant/hhpro/hhpro_cancel_button_click';
import managementClick from '@hh.ru/analytics-js-events/build/xhh/applicant/hhpro/hhpro_management_button_click';
import { translation, TranslatedComponent, useSelector } from '@hh.ru/front-static-app';
import { Button } from '@hh.ru/magritte-ui';
import { HhProSolidSize24 } from '@hh.ru/magritte-ui/service';
import { SPALink } from '@hh.ru/redux-spa-middleware';

import { FormState } from 'src/types/HhProFormState';

const TrlKeys = {
    cancel: 'hhpro.promo.state.active.cancel',
    management: 'hhpro.promo.state.active.management',
};

const CancelButton: TranslatedComponent<{
    stretched?: boolean;
    label: HhtmFromLabel;
    tariffId: string;
    setFormState: (state: FormState) => void;
}> = ({ stretched, setFormState, tariffId, label, trls }) => {
    const managementExperimentGroup = useSelector(
        ({ hhProManagementExperimentGroup }) => hhProManagementExperimentGroup
    );
    if (managementExperimentGroup) {
        return (
            <div className="magritte-night-theme">
                <Button
                    onClick={() => {
                        managementClick({ tariffId });
                    }}
                    Element={SPALink}
                    to="/applicant-services/hhpro/management?noredirect=true"
                    mode="primary"
                    style="neutral"
                    size="large"
                    stretched={stretched}
                    data-qa="hhpro-to-management-button"
                    icon={<HhProSolidSize24 />}
                >
                    {trls[TrlKeys.management]}
                </Button>
            </div>
        );
    }
    return (
        <div className="magritte-night-theme">
            <Button
                onClick={() => {
                    setFormState(FormState.Cancelation);
                    clickCancel({ tariffId, hhtmFromLabel: label });
                }}
                mode="secondary"
                style="negative"
                size="large"
                stretched={stretched}
                data-qa="hhpro-cancel-button"
            >
                {trls[TrlKeys.cancel]}
            </Button>
        </div>
    );
};

export default translation(CancelButton);
